import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const SalesTerms = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="icon" className="rounded-full">
              <ArrowLeft className="w-5 h-5" />
            </Button>
          </Link>
          <Link to="/" className="flex items-center gap-2">
            <span className="text-xl font-display font-bold text-primary">❤️ Flirra</span>
          </Link>
        </div>
      </header>

      <main className="pt-24 pb-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-display font-bold text-foreground mb-2">Handelsbetingelser</h1>
          <p className="text-muted-foreground mb-8">Sidst opdateret: Februar 2026</p>

          <div className="prose prose-slate dark:prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">1. Virksomhedsoplysninger</h2>
              <div className="bg-muted/50 rounded-xl p-6 text-muted-foreground">
                <p><strong className="text-foreground">Flirra</strong></p>
                <p>CVR-nummer: [Indsæt CVR]</p>
                <p>Adresse: [Indsæt adresse]</p>
                <p>Email: support@flirra.dk</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">2. Produkter og priser</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Flirra tilbyder følgende betalte produkter:
              </p>
              
              <div className="space-y-4">
                <div className="bg-muted/50 rounded-xl p-4">
                  <h3 className="font-semibold text-foreground mb-2">Premium Abonnementer</h3>
                  <ul className="list-disc pl-6 space-y-1 text-muted-foreground text-sm">
                    <li>Basis: 79 DKK/måned</li>
                    <li>Guld: 149 DKK/måned</li>
                    <li>Platin: 249 DKK/måned</li>
                  </ul>
                </div>
                
                <div className="bg-muted/50 rounded-xl p-4">
                  <h3 className="font-semibold text-foreground mb-2">Boost (engangskøb)</h3>
                  <ul className="list-disc pl-6 space-y-1 text-muted-foreground text-sm">
                    <li>3 timers boost: 149 DKK</li>
                    <li>12 timers boost: 249 DKK</li>
                    <li>24 timers boost: 349 DKK</li>
                  </ul>
                </div>
              </div>
              
              <p className="text-muted-foreground text-sm mt-4">
                Alle priser er inkl. moms. Priser kan ændres med 30 dages varsel.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">3. Betaling</h2>
              <p className="text-muted-foreground leading-relaxed">
                Vi accepterer betaling via:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-4">
                <li>Kreditkort (Visa, Mastercard)</li>
                <li>Apple Pay</li>
                <li>Google Pay</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mt-4">
                Betalinger behandles sikkert via Stripe. Vi gemmer ikke dine kortoplysninger.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">4. Abonnementer og fornyelse</h2>
              <p className="text-muted-foreground leading-relaxed">
                Premium-abonnementer fornyes automatisk hver måned, indtil du opsiger. 
                Du kan opsige når som helst via Indstillinger &gt; Abonnement. 
                Ved opsigelse har du adgang til premium-funktioner indtil periodens udløb.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">5. Fortrydelsesret</h2>
              <p className="text-muted-foreground leading-relaxed">
                I henhold til forbrugeraftaleloven har du 14 dages fortrydelsesret fra købsdatoen.
              </p>
              <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4 mt-4">
                <p className="text-amber-700 dark:text-amber-400 text-sm">
                  <strong>Vigtigt:</strong> Ved køb af digitalt indhold (Premium, Boost) accepterer du, at 
                  fortrydelsesretten bortfalder, når tjenesten aktiveres og leveres øjeblikkeligt efter købet.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">6. Refusion</h2>
              <p className="text-muted-foreground leading-relaxed">
                Da vores produkter er digitale tjenester, der leveres øjeblikkeligt, tilbyder vi 
                som udgangspunkt ikke refusion. I særlige tilfælde (tekniske fejl, dobbelt opkrævning) 
                kan du kontakte os for at anmode om refusion.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">7. Gratis prøveperiode</h2>
              <p className="text-muted-foreground leading-relaxed">
                Vi tilbyder en 3-dages gratis prøveperiode for nye brugere. Efter prøveperioden 
                fortsætter abonnementet automatisk til den valgte pris, medmindre du opsiger inden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">8. Levering</h2>
              <p className="text-muted-foreground leading-relaxed">
                Alle produkter leveres digitalt og aktiveres øjeblikkeligt efter gennemført betaling. 
                Du modtager en kvittering på email.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">9. Reklamation</h2>
              <p className="text-muted-foreground leading-relaxed">
                Ved tekniske problemer eller fejl i tjenesten, kontakt os inden for rimelig tid. 
                Vi vil forsøge at løse problemet eller tilbyde kompensation efter vores skøn.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">10. Klagemuligheder</h2>
              <p className="text-muted-foreground leading-relaxed">
                Kan vi ikke løse en tvist, kan du klage til:
              </p>
              <div className="bg-muted/50 rounded-xl p-4 mt-4 text-muted-foreground text-sm">
                <p><strong className="text-foreground">Center for Klageløsning</strong></p>
                <p>Nævnenes Hus</p>
                <p>Toldboden 2</p>
                <p>8800 Viborg</p>
                <p className="mt-2">
                  <a href="https://naevneneshus.dk" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                    www.naevneneshus.dk
                  </a>
                </p>
              </div>
              <p className="text-muted-foreground text-sm mt-4">
                Du kan også bruge EU-Kommissionens online klageportal:{' '}
                <a href="https://ec.europa.eu/odr" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                  https://ec.europa.eu/odr
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">11. Kontakt</h2>
              <p className="text-muted-foreground leading-relaxed">
                Har du spørgsmål om køb eller betaling? Kontakt os på:{' '}
                <a href="mailto:support@flirra.dk" className="text-primary hover:underline">support@flirra.dk</a>
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-8">
        <div className="max-w-4xl mx-auto px-4 flex flex-wrap gap-6 justify-center text-sm text-muted-foreground">
          <Link to="/privacy" className="hover:text-foreground">Privatlivspolitik</Link>
          <Link to="/terms" className="hover:text-foreground">Brugerbetingelser</Link>
          <Link to="/sales-terms" className="hover:text-foreground">Handelsbetingelser</Link>
        </div>
      </footer>
    </div>
  );
};

export default SalesTerms;
